import { render, staticRenderFns } from "./PriceWithNotesColumn.vue?vue&type=template&id=62e32221&"
import script from "./PriceWithNotesColumn.vue?vue&type=script&lang=js&"
export * from "./PriceWithNotesColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports